module.exports = __webpack_public_path__ + "cbf52c753556844440744c495d243b7a.jpg";